export default __webpack_public_path__ + "media/zurb/img/home/home-work-britney-aadaccce8afd1931fc7e7dbd2116286e.png";